// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p8NDG","rootNoMargin":"styles_rootNoMargin__9gw_M"};